import React, { Fragment } from "react";
import PropTypes from "prop-types";

const Strong = ({ children }) => {
  const pattern = /(?:\*\*)([^*]*)(?:\*\*)/g;
  const fragmentParts = [];
  let match;
  let index = 0;

  while ((match = pattern.exec(children))) {
    fragmentParts.push(children.slice(index, match.index));

    index = match.index + match[0].length;

    fragmentParts.push(<strong key={match.index}>{match[1]}</strong>);
  }

  fragmentParts.push(children.slice(index, children.length));

  return <Fragment>{fragmentParts}</Fragment>;
};

Strong.propTypes = {
  children: PropTypes.string
};

Strong.displayName = "MarkdownStrong";

export default Strong;



// WEBPACK FOOTER //
// ./js/components/Markdown/Strong.js